import { defineStore } from 'pinia'
import { useApi } from '@/api/useApi'
import { useBaseStore } from '@haskoning/vue-basestore'
import API from '@/api/apiUrls'
import type { TransportConfig } from './type/transportConfig.type'

const serviceURL = API.CALCULATION.TRANSPORT_CONFIGS.INDEX

export const useTransportConfigStore = defineStore('transportConfig', () => {
  const { api } = useApi()
  const baseStore = useBaseStore<TransportConfig>({ service: serviceURL, api })
  return {
    ...baseStore
  }
})
